import React from 'react';
const tomes = [{
  number: '01',
  title: 'Manual de Primer Año',
  desc: 'Anatomía, biología, química y matemática aplicada.'
}, {
  number: '02',
  title: 'Fisiología y Nutrición Normal',
  desc: 'Digestión, metabolismo, vitaminas y cálculo energético.'
}, {
  number: '03',
  title: 'El Libro de los Alimentos',
  desc: 'Bromatología, técnica dietética e higiene alimentaria.'
}, {
  number: '04',
  title: 'Guía de Enfermedades y Dietas',
  desc: 'Diabetes, obesidad, cardiovascular y renal con casos resueltos.'
}, {
  number: '05',
  title: 'Nutrición para Mamás y Niños',
  desc: 'Embarazo, lactancia, pediatría y adulto mayor.'
}, {
  number: '06',
  title: 'Salud Pública y Final de Carrera',
  desc: 'Epidemiología, EAN, legislación e investigación.'
}];
const includes = ['Fórmulas y cálculos listos para exámenes', 'Casos clínicos resueltos paso a paso', 'Checklists de conceptos clave', 'Resúmenes y autoevaluación por unidad'];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(255,255,255) 100%)'
  }} data-id="element-343">
      <div className="mx-auto max-w-4xl" data-id="element-344">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-345">
          Lo que <span className="text-green-700" data-id="element-346">recibís</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-347">
          6 tomos · +360 páginas · Toda la carrera organizada
        </p>

        {/* Tomos */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-348">
          {/* Header */}
          <div className="bg-green-700 px-5 py-2.5" data-id="element-349">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-350">
              📚 LOS 6 TOMOS — Toda la carrera en un solo lugar
            </h3>
          </div>

          {/* Tomes list */}
          <div className="divide-y divide-gray-100" data-id="element-351">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-2.5" data-id="element-352">
                <span className="shrink-0 text-lg font-black text-green-700/30 w-8 text-center" data-id="element-353">
                  {tome.number}
                </span>
                <div className="flex-1 min-w-0" data-id="element-354">
                  <span className="block text-sm font-black text-gray-900" data-id="element-355">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-356">
                    {tome.desc}
                  </span>
                </div>
                <span className="shrink-0 text-[10px] font-bold text-green-700 bg-green-700/5 border border-green-700/20 rounded-full px-2 py-0.5" data-id="element-357">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="grid grid-cols-2 gap-2" data-id="element-358">
          {includes.map(item => <div key={item} className="flex items-start gap-2 bg-white border border-green-700/20 rounded-lg px-4 py-2.5" data-id="element-359">
              <span className="shrink-0 text-green-700 font-bold text-sm" data-id="element-360">
                ✅
              </span>
              <span className="text-xs text-gray-700 leading-5" data-id="element-361">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}